module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "component-role"
  }, [_c('div', {
    staticClass: "inner-content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("RL" + _vm._s(_vm.item.id))]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _c('div', {
    staticClass: "column"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v("Description")]), _c('div', {
    staticClass: "field"
  }, [_vm._v(_vm._s(_vm.item.description))])]), _c('div', {
    staticClass: "column shrink align-self-middle"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'role',
        params: {
          id: _vm.item.id
        }
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-right fa-3x action"
  })])], 1)])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d0d97a26!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/backoffice/Role.vue
// module id = 2703
// module chunks = 1